import WithPageTransition from './with-page-transition'

export default WithPageTransition
